export const resourceTypes = {
    RESOURCES: 'RESOURCES',
    FILTERS: 'FILTERS',
    CLEAN_FILTERS: 'CLEAN_FILTERS',
    SERVICES_LIST: 'SERVICES_LIST',
    EVENTS_LIST: 'EVENTS_LIST',
    SPACES_LIST: 'SPACES_LIST',
    ROOMS_LIST: 'ROOMS_LIST'
}